import ItemsColumn from './components/ItemsColumn'
import { TransactionItem } from 'graphql'

function render( items: TransactionItem[] ) {
	return (
		<ItemsColumn items={items} />
	)
}

export default {
	field: 'transactionItems',
	name: 'Items',
	width: '120px',
	render,
}
